import React, { useEffect } from "react";
import { getIssueHistory } from "redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Checkbox } from "antd";
import { setUserPreference } from "redux/actions";
import moment from "moment";
import OBCSpinner from "./util/OBC";

const markerHistoryEnabledSelector = (state) => state.userPreferences.thermalHistory;

const ObservationHistoryComponent = ({ observation, openPreviewWithImage }) => {
    const dispatch = useDispatch();
    const [issueHistory, setIssueHistory] = React.useState([]);
    const [historyLoading, setHistoryLoading] = React.useState(false);
    const markerHistoryEnabled = useSelector(markerHistoryEnabledSelector);

    useEffect(() => {
        if (!observation || !observation.id || !markerHistoryEnabled) return;
        setHistoryLoading(true);
        dispatch(getIssueHistory(observation.id)).then((response) => {
            if (response.error) {
                console.error("Failed to fetch issue history:", response.error);
            } else {
                const sortedIssueHistory = response.sort((a, b) => {
                    return b.best_detection_ts - a.best_detection_ts;
                });
                setIssueHistory(sortedIssueHistory);
                setHistoryLoading(false);
            }
        });
    }, [dispatch, observation, markerHistoryEnabled]);

    return (
        <div className="MarkerHistoryItemsContainer">
            <Divider
                plain
                style={{ color: "white" }}>
                <Checkbox
                    onChange={(e) => dispatch(dispatch(setUserPreference("thermalHistory", e.target.checked)))}
                    checked={markerHistoryEnabled}>
                    Show Hotspot History
                </Checkbox>
            </Divider>
            {markerHistoryEnabled ? (
                <div className="MarkerHistoryContainer">
                    <div className="ItemsGrid">
                        {issueHistory.length > 0 ? (
                            issueHistory.map((issue, index) => {
                                const fromNow = moment(issue.best_detection_ts).fromNow();
                                let thumbnailUrl = `https://enhanced.aivr.video/${issue.device_key}/${issue.session_key}/${issue.video_key}.foi.Thermal%20Hotspot.jpg`;

                                if (issue.custom_thumbnail) {
                                    thumbnailUrl = issue.custom_thumbnail;
                                }

                                return (
                                    <div
                                        className="MarkerHistoryItem"
                                        key={index + issue.best_detection_ts}
                                        onClick={() => {
                                            openPreviewWithImage(thumbnailUrl, issue);
                                        }}>
                                        <img
                                            className="MarkerHistoryThumbnail"
                                            src={thumbnailUrl}
                                            alt="Thermal Hotspot"
                                        />
                                        {fromNow}
                                    </div>
                                );
                            })
                        ) : (
                            <div className="NoDetectionsText">
                                {historyLoading ? (
                                    <OBCSpinner
                                        size={"60"}
                                        colorScheme="mono"
                                    />
                                ) : (
                                    <p>No observation history available.</p>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default ObservationHistoryComponent;
